import { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { Btn, H3, P } from "../../../../AbstractElements";
import { MoscowLogin, StaticBackdropModal, StaticModalTitle } from "../../../../Constants/Constants";
import { StaticModalSubTitle } from "../../../../Data/UiKits/Modal";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import CommonModal from "../Common/CommonModal";
import StaticModalForm from "../Common/StaticModalForm";

const StaticModal = () => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const ModalData = {
    isOpen: modal,
    toggler: toggle,
    bodyClass: "dark-sign-up social-profile text-start",
  };

  return (
    <Col xl="4">
      <Card>
        <CommonCardHeader title={StaticModalTitle} span={StaticModalSubTitle} />
        <CardBody>
          <Btn color="primary" onClick={toggle}>
            {StaticBackdropModal}
          </Btn>
          <CommonModal modalData={ModalData}>
            <div className="modal-toggle-wrapper">
              <H3>{MoscowLogin}</H3>
              <P>{"Fill in your information below to continue."}</P>
              <StaticModalForm toggle={toggle} />
            </div>
          </CommonModal>
        </CardBody>
      </Card>
    </Col>
  );
};
export default StaticModal;
